import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Modal, Offcanvas, Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { getProductAction, modalToggleAction, updateProductAction, loadingToggleSingleProductAction } from '../../../store/actions/ProductActions';
import { dashboardProductStockOverview, getProductStocksByRack } from '../../../services/ProductService';
import { getProductCategoryList, getUnitList } from '../../../services/OtherService';
import ProjectOverviewChart from '../Dashboard/elements/ProjectOverviewChart';
import DataLoader from '../Dashboard/Loader';
import { toast } from 'react-toastify';
import StockHistoryTypeBadge from '../../constant/StockHistoryTypeBadge';

const EmptyProduct = {
    id: '',
    name: '',
    price: '',
    ucs_code: '',
    min_threshold: '',
    max_threshold: '',
    unit: 'KG',
    unit_type: 'multi',
    category: '',
    description: '',
    sap_description: '',
    ved_category: '',
    lead_time: '',
    perishable_product: false,
    is_active: true,
}

const ViewProduct = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const store = useSelector(state => state.products)
    const { user_permission, role } = useSelector(state => state.auth.user)
    const { stockUpdateKey } = useSelector(state => state.auth)
    const { selectProduct, productStockRacks, productStockHistory, recommendedStock, isModalOpen, modalType, isLoadingSingleProduct } = store
    const [categoryList, setCategoryList] = useState([])
    const [unitList, setUnitList] = useState([])
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [productEditValue, setProductEditValue] = useState(EmptyProduct)

    const [overViewData, setOverViewData] = useState(null)
    const [prodStock, setProdStock] = useState([])

    const recordsPage = 10;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = productStockRacks.slice(firstIndex, lastIndex);
    const npage = Math.ceil(productStockRacks.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)

    const handleOverviewChange = (view_type) => {
        dashboardProductStockOverview(id, view_type).then((response) => {
            setOverViewData(response.data.data)
        }).catch((error) => {
            console.log(error.response.data.message)
        });
    }


    useEffect(() => {
        dispatch(loadingToggleSingleProductAction(true))
        dispatch(getProductAction(id))
        handleOverviewChange('weekly')
    }, [id, stockUpdateKey])


    const toggleModal = (modal_type, rack_id = null) => {
        if (modal_type === "Edit") {
            if (isModalOpen) {
                setProductEditValue(EmptyProduct)
                setCategoryList([])
                setUnitList([])
            } else {
                getProductCategoryList().then(resp => {
                    setCategoryList(resp.data.data)
                }).catch(error => {
                    console.log(error)
                })
                getUnitList().then(resp => {
                    setUnitList(resp.data.data)
                }).catch(error => {
                    console.log(error)
                })
                setProductEditValue(
                    {
                        id: id, name: selectProduct.name,
                        price: selectProduct.price,
                        ucs_code: selectProduct.ucs_code,
                        min_threshold: selectProduct.min_threshold,
                        max_threshold: selectProduct.max_threshold,
                        unit: selectProduct.unit.id,
                        unit_type: selectProduct.is_mutli_type_unit ? 'multi' : 'single',
                        category: selectProduct.category ? selectProduct.category.id : '',
                        perishable_product: selectProduct.perishable_product,
                        description: selectProduct.description,
                        sap_description: selectProduct.description_sap,
                        ved_category: selectProduct.ved_category,
                        lead_time: selectProduct.lead_time,
                        is_active: selectProduct.is_active
                    })
            }
        } else if (modal_type === "RackStock") {
            getProductStocksByRack(id, rack_id).then((resp) => {
                setProdStock(resp.data.data)
            }).catch((error) => console.log("error", error.response.data.message))

        }
        dispatch(modalToggleAction(modal_type))
    }


    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }

    function changeCPage(id) {
        setCurrentPage(id);
    }

    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }


    const handleChangeEdit = (e) => {
        const { name, value } = e.target
        setProductEditValue({ ...productEditValue, [name]: value })
    }


    const handleEditSubmit = async (e) => {
        e.preventDefault()
        const requiredFieldValue = [productEditValue.id, productEditValue.name, productEditValue.ucs_code, productEditValue.unit, productEditValue.min_threshold]
        if (requiredFieldValue.some(itm => itm.length === 0)) {
            toast.error("Required all mandatory fields")
            return false
        } else {
            const data = { ...productEditValue, product_id: id }
            dispatch(updateProductAction(data))
        }
    }



    return (isLoadingSingleProduct ? <DataLoader height={"40rem"} marginTop={'20rem'} /> :
        <>
            {selectProduct != null ? (
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-3">
                            <div className="card">
                                <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
                                    <div className="d-flex align-items-center">
                                        <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm rounded-circle"
                                            style={{ padding: "5px 9px" }}
                                            onClick={() => navigate("/material")}
                                        ><i className="fa-solid fa-arrow-left"></i></button>
                                        <h4 className="mb-0 ms-2">Material Details</h4>
                                    </div>
                                    {(role === "Admin" || user_permission.manage_material) &&
                                        <button type="button" onClick={() => toggleModal("Edit")} className="btn btn-primary btn-sm">
                                            <i className="fa-solid fa-pen-to-square me-1" /><span>Edit </span>
                                        </button>
                                    }
                                </div>
                                <div className="card-body">
                                    <div className="">
                                        <ul>
                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div className='d-flex flex-column'>
                                                    <span>Material Name</span>
                                                    <strong>{selectProduct.name}</strong>
                                                </div>
                                            </li>
                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>UCS Code <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.ucs_code}</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Unit <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.unit.name}</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Threshold <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.min_threshold} - {selectProduct.max_threshold}</strong> (Min - Max)
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Category <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.category?.name}</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Price <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>₹ {selectProduct.price}</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Status <i className="fa-solid fa-arrow-right"></i></span>
                                                    {selectProduct?.is_active ?
                                                        <span className="badge badge-sm ms-1 badge-success">Active</span>
                                                        :
                                                        <span className="badge badge-sm ms-1 badge-danger">Inactive</span>
                                                    }
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>VED Category <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.ved_category}</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Lead Time <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.lead_time} days</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Unit Type <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.is_mutli_type_unit ? "Multi Items" : "Single Item"}</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Perishable Product <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.perishable_product ? "YES" : "NO"}</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Description <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.description}</strong>
                                                </div>
                                            </li>

                                            <li className='mb-3 d-flex align-items-center'>
                                                <div className='me-2 text-primary'>
                                                    <i className="fa-solid fa-asterisk"></i>
                                                </div>
                                                <div>
                                                    <span>Description SAP <i className="fa-solid fa-arrow-right"></i></span>
                                                    <strong className='ms-2'>{selectProduct.description_sap}</strong>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className='col-xl-9'>
                            <div className='row'>

                                <div className='col-md-6'>
                                    <div className="card">
                                        <div className="card-header py-3 d-flex align-items-center justify-content-between flex-wrap">
                                            <h4 className="mb-0">Stocks Quantities
                                                <span className={`badge badge-sm ms-1
                                    ${(selectProduct.net_quantity >= selectProduct.min_threshold && selectProduct.net_quantity <= selectProduct.max_threshold) ? 'badge-success' : selectProduct.net_quantity < selectProduct.min_threshold ? 'badge-danger' : 'badge-warning'}`}
                                                    style={{ fontSize: '1rem' }}
                                                >{selectProduct.net_quantity}</span></h4>
                                            <div>
                                            </div>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive active-projects style-1">
                                                <div id="customer-tblwrapper" className="dataTables_wrapper no-footer">
                                                    <table id="empoloyees-tbl1" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th>Rack</th>
                                                                <th>Net Quantity</th>
                                                                <th>View</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {records.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td><Link to={`/rack/${item.id}`}>{item.rack_no}</Link></td>
                                                                    <td>
                                                                        <span>{item.net_quantity}</span>
                                                                    </td>
                                                                    <td>
                                                                        <span className="badge badge-sm badge-primary c-pointer" onClick={() => toggleModal('RackStock', item.id)}><i className="fa-solid fa-eye"></i> View</span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <div className="d-sm-flex text-center justify-content-between align-items-center">
                                                        <div className='dataTables_info'>
                                                            Showing {lastIndex - recordsPage + 1} to{" "}
                                                            {/* {lastIndex}  */}
                                                            {productStockRacks.length < lastIndex ? productStockRacks.length : lastIndex}

                                                            {" "}of {productStockRacks.length} entries
                                                        </div>
                                                        <div
                                                            className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                            id="example2_paginate">
                                                            <Link
                                                                className="paginate_button previous disabled"
                                                                to="#"
                                                                onClick={prePage}
                                                            >
                                                                <i className="fa-solid fa-angle-left" />
                                                            </Link>
                                                            <span>
                                                                {number.map((n, i) => (
                                                                    <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                                        onClick={() => changeCPage(n)}
                                                                    >
                                                                        {n}

                                                                    </Link>
                                                                ))}
                                                            </span>
                                                            <Link
                                                                className="paginate_button next"
                                                                to="#"
                                                                onClick={nextPage}
                                                            >
                                                                <i className="fa-solid fa-angle-right" />
                                                            </Link>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-6'>
                                    <div className="card">
                                        <div className="card-header py-3 d-flex align-items-center justify-content-between flex-wrap">
                                            <h5 className="mb-0">Stockout Recommendations</h5>
                                            <Link to={`/product-stock/${id}`} className="btn btn-outline-primary btn-sm ms-2">Manage All Stocks</Link>
                                        </div>
                                        <div className="card-body p-0">
                                            <div className="table-responsive active-projects style-1">
                                                <table id="empoloyees-tbl1" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Barcode</th>
                                                            <th>Rack</th>
                                                            <th>Quantity</th>
                                                            <th>Stockin Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {recommendedStock?.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{item.barcode}</td>
                                                                <td>{item.rack}</td>
                                                                <td>{item.quantity} {item.expired_date &&
                                                                    <span className={`ms-2 fw-light ${new Date() > new Date(item.expired_date) ? 'text-danger' : ''}`}>
                                                                        <i className="fa-regular fa-clock"></i> {item.expired_date}</span>
                                                                }
                                                                </td>
                                                                <td>{item.created_at}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                <div className="d-sm-flex text-center justify-content-center align-items-center">
                                                    <div className='dataTables_info py-3'>
                                                        Top {recommendedStock.length} Stock Recommendations
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div className='col-xl-12'>
                            <div className="card mt-2 h-auto">
                                <div className="card-header py-3 d-flex align-items-center justify-content-between flex-wrap">
                                    <h3 className="mb-0">Stocks History</h3>
                                    <div>
                                        <Link to={`/stock_history/${selectProduct.id}`} type='button' className="btn btn-outline-primary btn-sm ms-2">View More</Link>
                                    </div>
                                </div>
                                <div className="card-body p-0">
                                    <div className="table-responsive active-projects style-1">
                                        <div id="customer-tblwrapper" className="dataTables_wrapper no-footer">
                                            <table id="empoloyees-tbl1" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Rack</th>
                                                        <th>Quantity</th>
                                                        <th>AMOUNT</th>
                                                        <th>Employee</th>
                                                        <th>Source / Purpose</th>
                                                        <th>DATE</th>
                                                        <th>STATUS</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {productStockHistory.map((item, index) => (
                                                        <tr key={index}>
                                                            <td><span>{item.stock.rack ? <Link to={`/rack/${item.stock.rack.id}`}>{item.stock.rack.rack_no}</Link> : null}</span></td>
                                                            <td>
                                                                <span>{item.quantity}</span>
                                                            </td>
                                                            <td>
                                                                <span>{item.stock.product.price * item.quantity}</span>
                                                            </td>
                                                            <td>
                                                                <span>{item?.employee?.name || ""}</span>
                                                            </td>
                                                            <td>
                                                                <span>
                                                                    {item.source ? item.source : item?.purpose ? (
                                                                        <small className="px-2 py-1 text-bg-light border border-light rounded-2">{item.purpose}</small>
                                                                    ) : ""}
                                                                </span>

                                                            </td>
                                                            <td>
                                                                <div className="d-flex flex-column">
                                                                    <span>{item.created_at}</span>
                                                                    <div>
                                                                        <StockHistoryTypeBadge historyType={item.history_type} />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {item.is_stock_out ? (
                                                                    <span className={`badge light border-0 badge-danger`}>OUT</span>
                                                                ) : (
                                                                    <span className={`badge light border-0 badge-success`}>IN</span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {overViewData ? <ProjectOverviewChart data={overViewData} handleChange={handleOverviewChange} /> : null}

                        </div>


                    </div>

                </div>
            ) : <h3>Invalid Material id {id}</h3>}


            {/* rack stock modal */}

            <Modal className="modal fade" id="exampleModal3" show={isModalOpen && modalType === "RackStock"} onHide={() => toggleModal("RackStock")}>
                <div className="modal-content">
                    <div className="modal-header ">
                        <h5 className="modal-title">Stocks</h5>
                        <button type="button" className="btn-close" onClick={() => toggleModal('RackStock')}></button>
                    </div>
                    <div className="modal-body">
                        <div className="table-responsive active-projects style-1">
                            <div id="customer-tblwrapper" className="dataTables_wrapper no-footer">
                                <table id="empoloyees-tbl1" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                    <thead>
                                        <tr>
                                            <th>Barcode</th>
                                            <th>Quantity</th>
                                            <th>Rack</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {prodStock.map((item, index) => (
                                            <tr key={index}>
                                                <td><span>{item.barcode__barcode_no}</span></td>
                                                <td>
                                                    <span>{item.quantity}</span>
                                                </td>
                                                <td>
                                                    {item.rack__rack_no}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>


            {/* edit product offcanvas */}
            <Offcanvas show={isModalOpen && modalType === "Edit"} onHide={() => toggleModal("Edit")} className="offcanvas-end customeoff" placement='end'>
                <div className="offcanvas-header">
                    <h5 className="modal-title" id="#gridSystemModal">Edit Product</h5>
                    <button type="button" className="btn-close"
                        onClick={() => toggleModal("Edit")}>
                        <i className="fa-solid fa-xmark"></i>
                    </button>
                </div>
                <div className="offcanvas-body">
                    <div className="container-fluid">
                        <Form onSubmit={(e) => handleEditSubmit(e)}>
                            <div className="row">
                                <div className="col-xl-6">
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Material Name <span className="text-danger">*</span></label>
                                        <input type="text" autoFocus className="form-control" id="name" placeholder="Enter Name"
                                            value={productEditValue.name} name='name' onChange={handleChangeEdit} required />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="ucs_code" className="form-label">UCS Code <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" id="ucs_code" placeholder="Enter UCS code"
                                            value={productEditValue.ucs_code} name='ucs_code' onChange={handleChangeEdit} required />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Unit <span className="text-danger">*</span></label>
                                        <select className="default-select form-control" name='unit' value={productEditValue.unit} onChange={handleChangeEdit} required>
                                            <option value="">Select Unit</option>
                                            {unitList.map((item, index) => (
                                                <option value={item.value} key={index}>{item.label}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="min_threshold" className="form-label">Min Threshold <span className="text-danger">*</span></label>
                                        <input type="number" className="form-control" id="min_threshold" placeholder="Enter Min Threshold"
                                            value={productEditValue.min_threshold} name='min_threshold' onChange={handleChangeEdit} required />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="max_threshold" className="form-label">Max Threshold </label>
                                        <input type="number" className="form-control" id="max_threshold" placeholder="Enter Max Threshold"
                                            value={productEditValue.max_threshold} name='max_threshold' onChange={handleChangeEdit} />
                                    </div>

                                    <div className="mb-1">
                                        <label>Unit Item Type</label><br />
                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio" className="form-check-input"
                                                id="unit_type_multi" name="unit_type" checked={productEditValue.unit_type === "multi"} value={'multi'} onChange={handleChangeEdit} />
                                            <label className="form-check-label" htmlFor="unit_type_multi">Multiple Items</label>
                                        </div>
                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio" className="form-check-input" defaultChecked
                                                id="unit_type_single" name="unit_type" checked={productEditValue.unit_type === "single"} value={'single'} onChange={handleChangeEdit} />
                                            <label className="form-check-label" htmlFor="unit_type_single">Single Item</label>
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label>Perishable Product </label><br />
                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio"
                                                className="form-check-input"
                                                id="Perishable_YES" name="perishable_product"
                                                checked={productEditValue.perishable_product}
                                                onChange={() => setProductEditValue({ ...productEditValue, perishable_product: true })} />
                                            <label className="form-check-label" htmlFor="Perishable_YES">YES</label>
                                        </div>

                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio" className="form-check-input"
                                                id="Perishable_NO" name="perishable_product"
                                                checked={!productEditValue.perishable_product}
                                                value={false}
                                                onChange={() => setProductEditValue({ ...productEditValue, perishable_product: false })} />
                                            <label className="form-check-label" htmlFor="Perishable_NO">NO</label>
                                        </div>
                                    </div>

                                </div>
                                <div className="col-xl-6">
                                    <div className="mb-3">
                                        <label htmlFor="price" className="form-label">Price </label>
                                        <input type="number" className="form-control" id="price" placeholder="Enter Price"
                                            value={productEditValue.price} name='price' onChange={handleChangeEdit} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">VED Category </label>
                                        <select className="default-select form-control" value={productEditValue.ved_category} name='ved_category' onChange={handleChangeEdit}>
                                            <option value="Vital">Vital</option>
                                            <option value="Essential">Essential</option>
                                            <option value="Desirable">Desirable</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="price" className="form-label">Lead Time (in Day)  </label>
                                        <input type="number" className="form-control" id="lead_time" placeholder="Enter Lead Time in day"
                                            value={productEditValue.lead_time} name='lead_time' onChange={handleChangeEdit} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Material Category </label>
                                        <select className="default-select form-control" name='category' value={productEditValue.category} onChange={handleChangeEdit}>
                                            <option value="">Select Category</option>
                                            {categoryList.map((item, index) => (
                                                <option value={item.value} key={index}>{item.label}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Description </label>
                                        <textarea style={{ minHeight: "30px" }} className="form-control" value={productEditValue.description} name='description' onChange={handleChangeEdit}></textarea>
                                    </div>
                                    <div className="col-xl-12 mb-3">
                                        <label className="form-label">description SAP</label>
                                        <textarea rows="2" className="form-control" value={productEditValue.sap_description} name='sap_description' onChange={handleChangeEdit}></textarea>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className={`${productEditValue.is_active ? 'alert-success' : 'alert-danger'} p-2 pb-0 rounded`}>
                                        <label className='fw-bolder'>Status</label>:
                                        <div className="form-check custom-checkbox mb-2 ms-3 form-check-inline">
                                            <input type="radio"
                                                className="form-check-input"
                                                id="status_YES" name="is_active"
                                                checked={productEditValue.is_active}
                                                onChange={() => setProductEditValue({ ...productEditValue, is_active: true })} />
                                            <label className="form-check-label" htmlFor="status_YES">Active</label>
                                        </div>

                                        <div className="form-check custom-checkbox mb-2 form-check-inline">
                                            <input type="radio" className="form-check-input"
                                                id="status_NO" name="is_active"
                                                checked={!productEditValue.is_active}
                                                value={false}
                                                onChange={() => setProductEditValue({ ...productEditValue, is_active: false })} />
                                            <label className="form-check-label" htmlFor="status_NO">Inactive</label>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='mb-3'>
                                        <button type="submit" className="btn btn-primary me-1">Update</button>
                                        <button type="button" onClick={() => toggleModal("Edit")} className="btn btn-danger light ms-1">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </Offcanvas>


        </>
    );
};

export default ViewProduct;